<template>
  <v-container fluid grid-list-lg>
    <v-card :loading="loading" outlined>
      <ListTitle
        :showBackButton="true"
        :access="false"
        title="Serial"
        :color="$style.purchase.titlebar"
      >
        <v-btn
          outlined
          rounded
          small
          class="ma-2"
          @click="extraCostDialog = true"
          >Extra Cost</v-btn
        >
        <v-btn outlined rounded small @click="changeStatusDialog = true"
          >Change Status</v-btn
        >
      </ListTitle>

      <v-toolbar dense elevation="0">
        <v-text-field
          v-model="search"
          outlined
          prepend-inner-icon="search"
          autofocus
          dense
          label="Search"
          single-line
          hide-details
          clearable
        />
        <template v-if="$vuetify.breakpoint.mdAndUp">
          <v-divider vertical class="mx-1"></v-divider>

          <v-overflow-btn
            :items="statusList"
            @change="getList()"
            return-object
            item-text="name"
            clearable
            editable
            outlined
            dense
            label="Department"
            v-model="selectedStatus"
            hide-details
            class="pa-0"
            overflow
          />
          <v-spacer></v-spacer>
        </template>

        <DateTimePicker
          :defaultRange="
            currentBusiness.metadata &&
            currentBusiness.metadata.invoiceViewLimit
              ? currentBusiness.metadata.invoiceViewLimit.range
              : 'since15DaysAgo'
          "
          :range="true"
          :hideTime="true"
          v-model="dateTime"
          @submit="getList()"
        />
      </v-toolbar>

      <v-divider></v-divider>

      <v-card-text>
        <v-data-table
          :mobile-breakpoint="0"
          :headers="headers"
          :items="vendors"
          :loading="loading"
          :server-items-length="count"
          :options.sync="options"
          :footer-props="{ 'items-per-page-options': [10, 15, 25, 50, 100] }"
        >
          <template v-slot:item="{ item }">
            <tr class="pointer">
              <td class="text-left">
                {{ item.createdAt | moment("MM/DD/YYYY") }}
              </td>

              <td
                class="text-left"
                v-html="$highlight(item.Product.name, search)"
              >
                {{ item.Product.name }}
              </td>

              <td>
                <v-layout row wrap>
                  <v-flex shrink>
                    <v-btn
                      @click="setOpenSerialSearch(item)"
                      text
                      icon
                      small
                      color="primary"
                    >
                      <v-icon small>mdi-feature-search-outline</v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex shrink>
                    <v-btn
                      text
                      icon
                      color="primary"
                      @click="copyCode(item.imeiNumber)"
                      small
                    >
                      <v-icon small>mdi-content-copy</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </td>

              <td
                class="text-left"
                v-html="$highlight(item.imeiNumber, search)"
              >
                {{ item.imeiNumber }}
              </td>

              <td
                class="text-left"
                v-html="$highlight(textCapitalize(item.status), search)"
              >
                {{ textCapitalize(item.status) }}
              </td>

              <td class="text-right">
                {{ item.cost | currency }}
              </td>
            </tr>
          </template>

          <v-alert slot="no-results" :value="true" color="error" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </v-data-table>
      </v-card-text>
    </v-card>
    <ExtraSerializedCost
      @close="extraCostDialog = false"
      @submit="getList()"
      :extraCostDialog="extraCostDialog"
    />

    <ChangeStatus
      @close="changeStatusDialog = false"
      @submit="getList()"
      :changeStatusDialog="changeStatusDialog"
    />
  </v-container>
</template>

<script>
import serialService from "@/modules/Inventory/Serial/service.js";
import { mapGetters, mapActions } from "vuex";
const RemoteOrderLink = () => import("@/components/RemoteOrderLink");
import ExtraSerializedCost from "@/modules/Inventory/Serial/ExtraSerializedCost/components/ExtraSerializedCost.vue";
import ChangeStatus from "@/modules/Inventory/Serial/components/ChangeStatus.vue";
const DateTimePicker = () => import("@/components/DateTimePicker");
import _ from "lodash";

export default {
  name: "serial-list",
  data() {
    return {
      selectedStatus: { id: "available", name: "Available" },
      statusList: [
        { id: "available", name: "Available" },
        { id: "sold", name: "Sold" },
        { id: "onHold", name: "On Hold" },
        { id: "repair", name: "Repair" },
      ],
      status: 0,
      createDialog: false,
      dateTime: {
        start: this.$moment()
          .startOf("days")
          .subtract(60, "days")
          .toISOString(),
        end: this.$moment().endOf("day").toISOString(),
      },
      editDialog: false,
      selectedvendor: null,
      changeStatusDialog: false,
      extraCostDialog: false,
      headers: [
        {
          text: "Created At",
          align: "left",
          value: "createdAt",
          sortable: true,
        }, // CHANGED: sortable true
        {
          text: "Product Name",
          align: "left",
          value: "Product.name",
          sortable: true,
        }, // CHANGED: sortable true (backend supports)
        { text: "", value: "action", sortable: false },
        {
          text: "IMEI Number",
          align: "left",
          value: "imeiNumber",
          sortable: true,
        }, // CHANGED: sortable true
        { text: "Status", align: "left", value: "status", sortable: true },
        { text: "Cost", value: "cost", sortable: true },
      ],

      vendors: [],
      count: 0,
      search: "",
      loading: true,

      // CHANGED: default sortBy to a real field; keep using options.sync for Vuetify server mode
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ["createdAt"], // CHANGED: was ['balance'] which isn't a column here
        sortDesc: [true],
      },
    };
  },
  created() {
    this.getList();
    document.title = "smplsale - Serial List";
  },
  computed: {
    ...mapGetters("global", [
      "currentUser",
      "checkRightStatus",
      "currentBusiness",
    ]),
  },
  components: {
    DateTimePicker,
    RemoteOrderLink,
    ChangeStatus,
    ExtraSerializedCost,
  },
  watch: {
    status() {
      this.getList();
    },
    // Debounced server search; trigger on clear or >=3 chars
    search: _.debounce(function () {
      if (
        this.search === null ||
        this.search.length === 0 ||
        this.search.length > 2
      ) {
        // reset to first page when search changes
        this.options.page = 1;
        this.getList();
      }
    }, 300),
    options: {
      handler() {
        this.getList();
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions("layout", ["setOpenSerialSearch", "setOpenRestockSerial"]),
    copyCode(code) {
      navigator.clipboard.writeText(code);
      this.$swal
        .mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: true,
          timer: 2000,
        })
        .fire({ icon: "success", title: "IMEI number was copy" });
    },
    textCapitalize(val) {
      const capitalizedText = val.charAt(0).toUpperCase() + val.slice(1);
      return capitalizedText;
    },
    viewProfile(val) {
      this.$router.push({ path: `/inventory/vendor/${val.id}/profile` });
    },
    add() {
      this.createDialog = !this.createDialog;
    },

    getList() {
      this.loading = true;
      this.changeStatusDialog = false;
      this.extraCostDialog = false;

      const { page, itemsPerPage, sortBy, sortDesc } = this.options;

      // offset calculation
      const limit = itemsPerPage > 0 ? itemsPerPage : 10;
      const offset = page && itemsPerPage > 0 ? (page - 1) * itemsPerPage : 0;

      // Vuetify may provide arrays; normalize to single field/dir
      const sb =
        Array.isArray(sortBy) && sortBy.length ? sortBy[0] : "createdAt";
      const sd =
        Array.isArray(sortDesc) && sortDesc.length ? !!sortDesc[0] : true;

      const where = {
        status: this.selectedStatus?.id,
        start: this.dateTime.start,
        end: this.dateTime.end,
        limit,
        offset,
        sortBy: sb, // <-- backend will map 'Product.name' as needed
        sortDesc: sd,
        // Back-compat for older handlers that expect orderBy[0/1]
        orderBy: [sb, String(sd)],
      };

      if (this.search && (this.search.length === 0 || this.search.length > 2)) {
        where.search = this.search;
      }

      return serialService
        .getAll(where)
        .then((response) => {
          this.loading = false;

          // Your API shape is { count, data } (no .data wrapper)
          this.count = Number(response.count) || 0;
          this.vendors = Array.isArray(response.data) ? response.data : [];

          return response;
        })
        .catch((err) => {
          this.loading = false;
          console.error("serial list load error:", err);
        });
    },
  },
};
</script>
